import { render } from "./DefinePackageModal.vue?vue&type=template&id=dd9940c8&ts=true"
import script from "./DefinePackageModal.vue?vue&type=script&lang=ts"
export * from "./DefinePackageModal.vue?vue&type=script&lang=ts"

import "./DefinePackageModal.vue?vue&type=style&index=0&id=dd9940c8&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__